import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4h-3v16h3","key":"svg-0"}],["path",{"d":"M16 4h3v16h-3","key":"svg-1"}]]

/**
 * IconBrackets
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhY2tldHMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTggNGgtM3YxNmgzIiAvPgogIDxwYXRoIGQ9Ik0xNiA0aDN2MTZoLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brackets
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrackets = createReactComponent('outline', 'brackets', 'Brackets', __iconNode);

export default IconBrackets;